import React, { useState } from "react";
import { Wrapper, InputWrapper, CalendarIcon, Label } from "./styled.js";
import { SingleDatePicker } from "react-dates";
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';


export const DateInput = ({label, placeholder, required,
                          value, onChange}) => {
    const [focus, setFocus] = useState(false);

    // TODO make this component a controlled one
    // handle updates to value
    const [date, setDate] = useState(value);

    return <Wrapper>
        {label && <Label required={required}>{label}</Label>}
        <InputWrapper>
            <CalendarIcon onClick={() => setFocus(!focus)}/>
            <SingleDatePicker
                placeholder={placeholder}
                required={required}
                noBorder
                hideKeyboardShortcutsPanel
                numberOfMonths={1}
                onDateChange={(date) => {
                    setFocus(false);
                    setDate(date);
                    if (onChange) {
                        onChange(date ? date.toDate(): '');
                    }
                }}
                date={date}
                focused={focus}
                onFocusChange={({focused}) => setFocus(focused)}
            />
        </InputWrapper>
    </Wrapper>
};

export default DateInput;
